module.exports = __webpack_public_path__ + "static/grupaazoty-ca7860774a38d8461993360afe2dcdfe.png";